import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib';
import {
  cancelCheckinPassengerInputResultRequest,
  failCheckinPassengerInputResult,
  setCheckinPassengerInputResult,
  setCheckinPassengerInputResultFromApi,
  updateCheckinPassengerInputResult,
  updateCheckinPassengerInputResultFromApi,
} from './checkin-passenger-input-result.actions';

/**
 * Service to handle async CheckinPassengerInputResult actions
 */
@Injectable()
export class CheckinPassengerInputResultEffect {
  /**
   * Set the state with the reply content, dispatch failCheckinPassengerInputResult if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setCheckinPassengerInputResultFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setCheckinPassengerInputResult({ ...reply, requestId: action.requestId }),
        (error, action) => of(failCheckinPassengerInputResult({ error, requestId: action.requestId })),
        cancelCheckinPassengerInputResultRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failCheckinPassengerInputResult if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateCheckinPassengerInputResultFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateCheckinPassengerInputResult({ ...reply, requestId: payload.requestId })),
          catchError((err) => of(failCheckinPassengerInputResult({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
